export default __webpack_public_path__ + "static/spinner@2x.62cf7fe84546f4ed1d0622da25dcb2ba.gif";